import React from "react";
import { string, oneOfType, oneOf, arrayOf, node, bool, func, object } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { Button } from "../../Button";

const CardButton = ({
	children,
	to,
	onClick,
	target,
	icon,
	iconPlacement,
	outline,
	className,
	label,
	size,
	modal,
	modalContent,
	variant,
}) => {
	if (modalContent && modal) {
		const Modal = modal;
		return (
			<Modal contentLabel="content details">
				<Modal.Trigger>
					<Button
						to={to}
						onClick={onClick}
						target={target}
						icon={icon || ""}
						iconPlacement={iconPlacement}
						label={children || label}
						outline={outline}
						className={className}
						size={size}
					/>
				</Modal.Trigger>
				<Modal.Content style={{ textAlign: "left" }}>{modalContent}</Modal.Content>
			</Modal>
		);
	}
	return (
		<Button
			to={to}
			onClick={onClick}
			target={target}
			icon={icon || ""}
			iconPlacement={iconPlacement}
			label={children || label}
			outline={outline}
			className={className}
			size={size}
			variant={variant}
		/>
	);
};

CardButton.propTypes = {
	children: oneOfType([arrayOf(node), node]).isRequired,
	to: string,
	onClick: func,
	target: string,
	className: string,
	label: string,
	icon: string,
	iconPlacement: oneOf(["right", "left"]),
	size: oneOf(["sm", "md", "lg", "auto"]),
	outline: bool,
	modal: object,
	modalContent: node,
	variant: string,
};

CardButton.defaultProps = {
	to: "",
	onClick: () => {},
	target: "",
	icon: undefined,
	iconPlacement: undefined,
	className: "",
	outline: false,
	label: "",
	size: "md",
	modal: undefined,
	modalContent: undefined,
	variant: "",
};

export default CardButton;
export { CardButton };
